var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckoutComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33362 14.6667L20.9503 14.6667L12.817 22.8C12.167 23.45 12.167 24.5167 12.817 25.1667C12.9711 25.3212 13.1543 25.4437 13.3559 25.5274C13.5575 25.611 13.7737 25.6541 13.992 25.6541C14.2102 25.6541 14.4264 25.611 14.628 25.5274C14.8296 25.4437 15.0128 25.3212 15.167 25.1667L26.1503 14.1833C26.3048 14.0291 26.4274 13.846 26.511 13.6444C26.5946 13.4427 26.6377 13.2266 26.6377 13.0083C26.6377 12.79 26.5946 12.5739 26.511 12.3723C26.4274 12.1707 26.3048 11.9875 26.1503 11.8333L15.1836 0.833319C15.0293 0.679015 14.8461 0.556615 14.6445 0.473107C14.4429 0.389599 14.2268 0.346618 14.0086 0.346618C13.7904 0.346618 13.5743 0.389599 13.3727 0.473107C13.1711 0.556615 12.9879 0.679015 12.8336 0.833319C12.6793 0.987622 12.5569 1.17081 12.4734 1.37241C12.3899 1.57402 12.3469 1.7901 12.3469 2.00832C12.3469 2.22654 12.3899 2.44262 12.4734 2.64422C12.5569 2.84583 12.6793 3.02902 12.8336 3.18332L20.9503 11.3333L2.33362 11.3333C1.41695 11.3333 0.666954 12.0833 0.666953 13C0.666953 13.9167 1.41695 14.6667 2.33362 14.6667Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckoutComplete);
export default __webpack_public_path__ + "static/media/checkout-complete.a875fe5c9adae9016a50fdddb15003c8.svg";
export { ForwardRef as ReactComponent };